module.exports = __webpack_public_path__ + "static/media/5.e1c30d1d.jpg";